// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LcHv","left":"styles_left__2Fh08"};